/**
 * UID 输入框：仅允许数字，输入/粘贴时自动过滤非数字。
 * IME 组字（如中文拼音未上屏）期间不处理 input，避免误删已输入数字。
 */
export default {
  data() {
    return {
      uidComposing: false
    };
  },
  methods: {
    onUidCompositionStart() {
      this.uidComposing = true;
    },
    onUidCompositionEnd(e) {
      this.uidComposing = false;
      this.onUidInput(e);
    },
    onUidInput(e) {
      if (this.uidComposing) {
        return;
      }
      const next = (e.target.value || '').replace(/\D/g, '');
      if (e.target.value !== next) {
        e.target.value = next;
      }
      this.uid = next;
    }
  }
};
